import 'slick-carousel';

const $tabsCarousel = $('.js-36v-tabs');

$tabsCarousel.slick({
  dots: true,
  infinite: false,
  slidesToShow: 3,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

function initResizeCarousel() {
  const carousel = $tabsCarousel;
  const track = carousel.find('.slick-track');
  const items = carousel.find('.item').length;

  if (window.matchMedia('(min-width: 1200px)').matches) {
    if (items < 3) {
      track.addClass('center');
    } else {
      track.removeClass('center');
    }
  }
}

$(window).resize(() => {
  initResizeCarousel();
});
initResizeCarousel();

// Custom class toggling for bootstrap tabs as carousel caused issues with "active" class name
$('.tabs .js-36v-tabs a').click(() => {
  $('.tabs ul li.active').removeClass('active');
  $(this).parent('li').addClass('active');
});
